import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { MachineDowntime, MachineDowntimeCreate, MachineDowntimeFilter } from '../data/machineDowntime';

export function createMachineDowntimeService(client: AxiosInstance) {
  return createCrudService<MachineDowntime, MachineDowntimeCreate, MachineDowntimeFilter>(
    client,
    '/manufacturing/MachineDowntime',
    'id',
  );
}

export type MachineDowntimeService = CrudService<MachineDowntime, MachineDowntimeCreate, MachineDowntimeFilter>;
